var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.date)+" — "),_c('strong',[_vm._v("123NET")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }